import { DateTime } from 'luxon';
import React from 'react';
import CurrencyFormat from 'react-currency-format';
import { useTranslation } from 'react-i18next';
import { fromDBToLocalTimestamp, toLocalTimestamp } from '../helpers/date';

export const GenDateRangeDataFormat = ({
  dateFrom = new Date(),
  dateTo = new Date(),
}) => {
  return (
    <>
      {<GenDate date={dateFrom} noTime={true} />} -{' '}
      {<GenDate date={dateTo} noTime={true} />}
    </>
  );
};

export const GenDate = ({ date, noTime = false, utcTime = true }) => {
  const { t } = useTranslation('global');

  const format = noTime ? DateTime.DATE_SHORT : DateTime.DATETIME_SHORT;
  const formattedDate = utcTime
    ? fromDBToLocalTimestamp(date, format)
    : toLocalTimestamp(date, format);

  return formattedDate ? formattedDate : t('notAvailable');
};

export const GenCurrency = props => {
  const { value = undefined, allowNegative = false, ...opts } = props;

  const handleFalsyValue = val => {
    if (val === null || isNaN(val)) {
      return undefined;
    } else {
      return val;
    }
  };

  return (
    <CurrencyFormat
      value={handleFalsyValue(value)}
      allowNegative={allowNegative}
      displayType={'text'}
      thousandSeparator={true}
      decimalScale={2}
      prefix={'$'}
      fixedDecimalScale={true}
      {...opts}
    />
  );
};
